/**
 * @description 扩展方法，提供 gl-matrix 为提供的方法
 **/
export { transform } from './transform';
export { angleTo } from './angle-to';
export { direction } from './direction';
export { vertical } from './vertical';
//# sourceMappingURL=index.js.map